import {bech32} from "bech32";
import * as baseX from 'base-x';
import sha256 from "sha256/lib/sha256";

export default {
  network() {
    return {
      mainnet: "mainnet",
      testnet: "testnet",
      regtest: "regtest"
    }
  },
  addressType() {
    return {
      p2pkh: "p2pkh",
      p2sh: "p2sh",
      p2wpkh: "p2wpkh",
      p2wsh: "p2wsh",
    }
  },
  addressTypes() {
    return {
      0x00: {
        type: this.addressType().p2pkh,
        network: this.network().mainnet,
      },

      0x6f: {
        type: this.addressType().p2pkh,
        network: this.network().testnet,
      },

      0x05: {
        type: this.addressType().p2sh,
        network: this.network().mainnet,
      },

      0xc4: {
        type: this.addressType().p2sh,
        network: this.network().testnet,
      },
    };
  },
  bech32Decode(str) {
    return bech32.decode(str);
  },
  bech32FromWords(words) {
    return bech32.fromWords(words);
  },
  base58() {
    return baseX('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz');
  },
  base58Decode(str) {
    return this.base58().decode(str);
  },
  parseBech32(address) {
    let decoded;

    try {
      decoded = this.bech32Decode(address);
    } catch (error) {
      throw new Error('Invalid address');
    }

    const mapPrefixToNetwork = {
      'bc': this.network().mainnet,
      'tb': this.network().testnet,
      'bcrt': this.network().regtest,
    };

    const network = mapPrefixToNetwork[decoded.prefix];

    if (network === undefined) {
      throw new Error('Invalid address');
    }

    const witnessVersion = decoded.words[0];

    if (witnessVersion < 0 || witnessVersion > 16) {
      throw new Error('Invalid address');
    }

    const data = this.bech32FromWords(decoded.words.slice(1));

    const type = data.length === 20 ? this.addressType().p2wpkh : this.addressType().p2wsh;

    return {
      bech32: true,
      network,
      address,
      type,
    };
  },
  parseAddress(address) {
    let decoded;
    const prefix = address.substr(0, 2);

    if (prefix === 'bc' || prefix === 'tb') {
      return this.parseBech32(address);
    }

    try {
      decoded = this.base58Decode(address);
    } catch (error) {
      throw new Error('Invalid address');
    }

    const { length } = decoded;

    if (length !== 25) {
      throw new Error('Invalid address');
    }

    const version = decoded[0];

    const checksum = decoded.slice(length - 4, length);
    const body = decoded.slice(0, length - 4);

    /*const shaFirst = sha256.x2(body);
    const shaSecond = sha256(shaFirst);*/
    const expectedChecksum = sha256.x2(body).slice(0, 8);

    if (checksum[0] !== parseInt(expectedChecksum.slice(0, 2), '16') ||
      checksum[1] !== parseInt(expectedChecksum.slice(2, 4), '16') ||
      checksum[2] !== parseInt(expectedChecksum.slice(4, 6), '16') ||
      checksum[3] !== parseInt(expectedChecksum.slice(6, 8), '16')) {
      throw new Error('Invalid address');
    }

    const validVersions = Object.keys(this.addressTypes()).map(Number);

    if (!validVersions.includes(version)) {
      throw new Error('Invalid address');
    }

    const addressType = this.addressTypes()[version];

    return {
      ...addressType,
      address,
      bech32: false,
    }
  }
}